<template>
    <div class="smartDevice">
    </div>
</template>

<script>
import url from "../../service/base-url.js";
export default {
  name: "smartDevice",
  mounted() {
    var win = window.open(url.smartDevice, "_blank");
    win.focus();
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
